import { PiArrowFatLinesUpFill } from "react-icons/pi";

interface PictureListActionsProps {
  isSelectionMode: boolean;
  selectedCount: number;
  isReuploading: boolean;
  onSelectMode: () => void;
  onSelectAll: () => void;
  onCancelSelection: () => void;
  onReupload: () => void;
}

const PictureListActions = ({
  isSelectionMode,
  selectedCount,
  isReuploading,
  onSelectMode,
  onSelectAll,
  onCancelSelection,
  onReupload,
}: PictureListActionsProps) => {
  const outlineButtonClass =
    "flex items-center h-7 px-2 text-xs font-semibold rounded border border-[#EC6E7D] bg-white text-[#EC6E7D] hover:bg-[#FFF1F3] transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white";
  const filledButtonClass =
    "flex items-center h-7 px-2 text-xs font-semibold rounded bg-[#EC6E7D] text-white hover:bg-[#E45F70] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  const cancelButtonClass =
    "flex items-center h-7 px-2 text-xs font-semibold rounded bg-[#BFBFBF] text-white hover:bg-[#AFAFAF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  const isReuploadDisabled =
    !isSelectionMode || selectedCount === 0 || isReuploading;

  return (
    <div className="flex flex-col items-end gap-1">
      {isSelectionMode && (
        <span className="text-xs text-[#3F3F3F]">{selectedCount}件選択中</span>
      )}
      <div className="flex items-center gap-2">
        {!isSelectionMode ? (
          <button
            type="button"
            className={outlineButtonClass}
            onClick={onSelectMode}
          >
            選択
          </button>
        ) : (
          <>
            <button
              type="button"
              className={filledButtonClass}
              onClick={onSelectAll}
            >
              すべて選択
            </button>
            <button
              type="button"
              className={cancelButtonClass}
              onClick={onCancelSelection}
            >
              キャンセル
            </button>
          </>
        )}
        <button
          type="button"
          className={outlineButtonClass}
          onClick={onReupload}
          disabled={isReuploadDisabled}
        >
          <span className="w-5 h-5 rounded-full border border-[#EC6E7D] text-[#EC6E7D] flex items-center justify-center me-1">
            <PiArrowFatLinesUpFill className="text-xs" />
          </span>
          再アップロード
        </button>
      </div>
    </div>
  );
};

export default PictureListActions;
